import { io } from 'socket.io-client';

export const getSocketConfig = () => ({
  transports: ['websocket', 'polling'],
  closeOnBeforeunload: true,
  maxHttpBufferSize: 1e8,
  query: {
    userId: localStorage.getItem('Id'),
    userAgent: navigator.userAgent,
    token: `Bearer ${localStorage.getItem('token')}`,
  },
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 15,
});

class SocketClient {
  socketConnection;

  connect() {
    if (this.socketConnection) return;

    this.socketConnection = io(
      `${process.env.REACT_APP_SOCKET_HOST}`,
      getSocketConfig(),
    );

    return this.socketConnection;
  }

  get connected() {
    return Boolean(this.socketConnection?.connected);
  }

  emit(event, payload, ack) {
    if (!this.socketConnection) return;
    return this.socketConnection.timeout(10000).emitWithAck(event, payload);
  }
}

export const socketClient = new SocketClient();

window.socketClient = socketClient;